import { render, staticRenderFns } from "./OTPLoader.vue?vue&type=template&id=4e51d887&scoped=true&"
import script from "./OTPLoader.vue?vue&type=script&lang=js&"
export * from "./OTPLoader.vue?vue&type=script&lang=js&"
import style0 from "./OTPLoader.vue?vue&type=style&index=0&id=4e51d887&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e51d887",
  null
  
)

export default component.exports